import script from "./HeaderIhecs.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderIhecs.vue?vue&type=script&setup=true&lang=js"

import "./HeaderIhecs.vue?vue&type=style&index=0&id=1db5e7cf&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1db5e7cf"]])

export default __exports__